import { render, staticRenderFns } from "./AtualizarCadastro.vue?vue&type=template&id=380ff230&scoped=true"
import script from "./AtualizarCadastro.vue?vue&type=script&lang=js"
export * from "./AtualizarCadastro.vue?vue&type=script&lang=js"
import style0 from "./AtualizarCadastro.vue?vue&type=style&index=0&id=380ff230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380ff230",
  null
  
)

export default component.exports